<template>
  <div class="inputWrapper">
    <div class="input">
      <input
        :id="name"
        :name="name"
        :type="type"
        :placeholder="label"
        :value="value"
        @input="input"
        @blur="blur"
        :disabled="disabled"
        :class="{ empty: value.length === 0, error: error.length > 0 }"
      />
      <label :for="name">{{ label }}</label>
    </div>
    <p class="errorMessage">{{ error || '&nbsp;' }}</p>
  </div>
</template>

<style scoped>
  .inputWrapper {
    position: relative;
    margin: 10px 0 20px 0;
  }

  .input > input {
    height: 5rem;
    width: 100%;
    box-sizing: border-box;
    margin: 10px 0 5px 0;
    padding: 10px;
    font-family: inherit;
    font-size: 1.4rem;
    color: inherit;
    background-color: var(--secondary-background-color);
    border: none;
    border-bottom: 2px solid var(--primary-color);
    border-radius: 3px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
    outline: none;
    transition-property: border-color box-shadow;
    transition-duration: 0.3s;
  }

  .input > input:focus {
    border-color: var(--secondary-color);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1), inset 0 0 2px var(--secondary-color);
  }

  .input > input::placeholder {
    color: transparent;
  }

  .input > label {
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 0;
    pointer-events: none;
    transition-property: top, left;
    transition-duration: 0.3s;
  }

  .input > input.empty + label {
    top: 3.5rem;
    left: 2rem;
  }

  .input > input:focus + label,
  .input > input:-internal-autofill-selected + label {
    top: 0;
    left: 0;
  }

  .input > input.error {
    border-color: var(--error-color);
  }

  .errorMessage {
    height: 10px;
    margin: 0;
    padding: 0;
    font-size: 1.2rem;
    line-height: 1;
    color: var(--error-color);
  }
</style>

<script>
  export default {
    props: [
      'type',
      'name',
      'label',
      'value',
      'error',
      'input',
      'blur',
      'disabled'
    ]
  }
</script>
